// Static content for the careers page (Figma node 3811:20783).
// Roles are hard-coded for now; this is the shape an ATS feed would fill later.
import { coreValues } from "../about/coreValues";

// The three values are the same copy as the About page, so the text lives in one
// place and cannot drift. Only the careers-specific surface treatment is added
// here: on this page the active panel is Bright Blue/700 and the others are the
// deep navy and pale cards from the design.
const PANEL_SURFACES = {
    partnership: { background: "#101936", letterColor: "#95C3FB", titleColor: "#FFFFFF", bodyColor: "rgba(255,255,255,0.8)" },
    purpose: { background: "#204CD5", letterColor: "#FFFFFF", titleColor: "#FFFFFF", bodyColor: "rgba(255,255,255,0.8)" },
    further: { background: "#F8F8F8", letterColor: "#182553", titleColor: "#0F1424", bodyColor: "#454954" },
};

export const careerValues = coreValues.map((value) => ({
    id: value.id,
    letter: value.letter,
    title: value.title,
    description: value.description,
    ...PANEL_SURFACES[value.id],
}));

export const benefits = [
    {
        id: "flexibility",
        icon: "heartHandshake",
        title: "People-first flexibility",
        description: "Work where you do your best, with clear expectations and room for life outside the workday.",
    },
    {
        id: "ownership",
        icon: "settings",
        title: "Trusted to own your work",
        description: "Management by trust means room to work your way. You own your outcomes, and we have your back.",
    },
    {
        id: "systems",
        icon: "tools",
        title: "Set up to succeed",
        description: "Tight systems and clear expectations, so you can focus on great work instead of chasing chaos.",
    },
    {
        id: "team",
        icon: "users",
        title: "A true team of partners",
        description: "Collaborate with experienced, generous people who share context, celebrate wins, and follow through.",
    },
];
